import React from 'react';

import {cls} from '../../../../components/utils';

import css from './sheet.module.css';

type Props = {
	total: number;
	/** сколько отметок закрашено; закрашенные идут первыми */
	filled: number;
	/** подпись для экранных дикторов */
	label: string;
	danger?: boolean;
	/** квадраты — тратящиеся ресурсы: ячейки заклинаний и использования; кружки — отметки вроде испытаний против смерти */
	shape?: 'circle' | 'square';
	/** мелкие отметки: для тесных мест вроде строки показателей */
	small?: boolean;
	/** без обработчика отметки только показывают состояние */
	onChange?(filled: number): void;
};

export const Marks: React.FC<Props> = ({total, filled, label, danger, shape = 'circle', small, onChange}) => (
	<span className={css.marks} role="group" aria-label={`${label}: ${filled} из ${total}`}>
		{Array.from({length: total}, (_, index) => {
			const isFilled = index < filled;
			const className = cls(
				css.mark,
				shape === 'square' && css.markSquare,
				small && css.markSmall,
				isFilled && css.markFilled,
				danger && css.markDanger,
				!onChange && css.markStatic,
			);
			return onChange ? (
				<button
					key={index}
					type="button"
					className={className}
					aria-label={isFilled ? `${label}: убрать отметку` : `${label}: отметить`}
					onClick={() => onChange(isFilled ? filled - 1 : filled + 1)}
				/>
			) : (
				<span key={index} className={className} />
			);
		})}
	</span>
);
